<ng-template #template>
  <dl class="c-float-list01">
    <div class="c-float-list01__item c-float-list01__item--mt4">
      <dt
        class="c-float-list01__title c-float-list01__title--gray90"
        [attr.aria-label]="titleAria"
        [class]="titleClass"
      >
        {{ title }}
      </dt>
      <dd class="c-float-list01__contents" [class]="contentClass">{{ content }}</dd>
    </div>
  </dl>
</ng-template>
